"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 *
 * @export
 * @class Adal4User
 */
var Adal4User = (function () {
    function Adal4User() {
    }
    return Adal4User;
}());
exports.Adal4User = Adal4User;



//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/~/adal-angular4/adal4-user.js
// module id = ../../../../adal-angular4/adal4-user.js
// module chunks = 4